module.exports = __webpack_public_path__ + "static/24-8965a046f030e7fd090ee7b9198d50b1.png";